import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ImagePlus = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 9.3V14.4L16.5 12.9C15.4 11.9 13.7 11.9 12.6 12.9L11.9 13.6L9.4 11.1C8.3 10.1 6.6 10.1 5.5 11.1L4 12.6V7C4 6.4 4.4 6 5 6H14.7C14.4 5.4 14.4 4.6 14.7 4H5C3.3 4 2 5.3 2 7V19C2 20.7 3.3 22 5 22H17C18.7 22 20 20.7 20 19V9.3C19.7 9.4 19.3 9.5 19 9.5C18.7 9.5 18.3 9.4 18 9.3ZM21 4H20V3C20 2.4 19.6 2 19 2C18.4 2 18 2.4 18 3V4H17C16.4 4 16 4.4 16 5C16 5.6 16.4 6 17 6H18V7C18 7.6 18.4 8 19 8C19.6 8 20 7.6 20 7V6H21C21.6 6 22 5.6 22 5C22 4.4 21.6 4 21 4Z"
      fill="currentColor"
    />
  </svg>
)

export default ImagePlus
